import HelperText from 'components/HelperText';
import Label from 'components/Label';
import { getRandomId } from 'utils/uid.utils';
import { useRef } from 'preact/hooks';
import { CustomText } from 'components/CustomText';
import { IconWrapper, InputWrapper } from './Input.styles';

interface InputProps {
  name: string;
  className?: string;
  value: string;
  onChange: (event: any) => void;
  onBlur?: (event: any) => void;
  label?: string;
  placeholder?: string;
  error?: string;
  icon?: JSX.Element;
  required?: boolean;
  labelTooltip?: string;
}

const Input = ({
  name,
  label,
  value = '',
  className,
  placeholder,
  error,
  icon: Icon,
  required,
  onChange = () => undefined,
  onBlur = () => undefined,
  labelTooltip,
}: InputProps): JSX.Element => {
  const idRef = useRef(`${name}-${getRandomId()}`);
  const id = idRef.current;

  return (
    <Label
      className={className}
      label={label}
      htmlFor={id}
      labelTooltip={labelTooltip}
    >
      <InputWrapper
        id={id}
        value={value}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        hasError={!!error}
        required={required}
        data-testid="input"
      />
      {Icon && <IconWrapper>{Icon}</IconWrapper>}
      {error && <CustomText as={HelperText} text={error} isError size="md" />}
    </Label>
  );
};

export default Input;
